import React, { type ReactNode } from 'react';

import { AnimatePresence, LayoutGroup } from 'framer-motion';

import { StyledCardGrid, StyledItem } from './styles';

export interface CardGridProps {
    children: ReactNode;
    compact?: boolean;
}

interface ItemProps {
    children: ReactNode;
}

export function CardGrid({ children, compact = false }: CardGridProps) {
    return (
        <StyledCardGrid $compact={compact}>
            <LayoutGroup>
                <AnimatePresence>{children}</AnimatePresence>
            </LayoutGroup>
        </StyledCardGrid>
    );
}

function Item({ children }: ItemProps) {
    return <StyledItem>{children}</StyledItem>;
}

CardGrid.Item = Item;
